import React from 'react';
import { QuoteIcon } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  position: string;
  company: string;
}
export function TestimonialCard({
  quote,
  author,
  position,
  company
}: TestimonialCardProps) {
  return <div className="bg-white p-8 rounded-lg shadow-md luxury-border elegant-card" data-id="element-191">
      <QuoteIcon size={24} className="accent-color mb-4" data-id="element-192" />
      <p className="text-gray-700 mb-6 italic leading-relaxed" data-id="element-193">"{quote}"</p>
      <div className="border-t border-gray-100 pt-4" data-id="element-194">
        <p className="font-bold" data-id="element-195">{author}</p>
        <p className="text-gray-600" data-id="element-196">
          {position}, {company}
        </p>
      </div>
    </div>;
}